import { Component } from 'react';
import ErrorPage from './ErrorPage';

export default class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Application render failed.', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage statusCode={500} />;
    }

    return this.props.children;
  }
}
